export default __webpack_public_path__ + "/dist/images/about-img1.653c1339d17147ac8c857dc94f350fae.png";